import styled from 'styled-components/macro'

export default styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${props => props.theme.margin};
  border-top:  1px solid ${props => props.theme.colors.gray[3]};
  border-bottom: 1px solid ${props => props.theme.colors.gray[3]};
  padding: 0;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    box-shadow: white 0px 80px 60px -3em inset, white 0px -80px 60px -3em inset;
    pointer-events: none;
  }
`

export const Select = styled.div`
    width: 30%;
    font-size: 1.1rem;
    text-align: center;
    background-color: white;
    color: ${props => props.theme.colors.gray[1]};
    border: 0;
    border-radius: 0;
    outline: none;
    /* padding: 40px 0; */
    height: 190px;
    overflow-y: auto;
    scroll-snap-type: y mandatory;
  
    &::-webkit-scrollbar {
      width: 0;
    }
`

export const Option = styled.div`
  padding: ${props => props.theme.halfSpace};
  border-radius: ${props => props.theme.borderRadius};
  color: ${props => props.theme.colors.gray[0]};
  scroll-snap-align: center;
  scroll-snap-stop: always;
  cursor: pointer;
  /* height: 40px; */

  &.selected {
    color: ${props => props.theme.colors.orange};
    font-weight: bold;
  }
`

export const BirthDate = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
  max-width: 400px;
  margin: 0 auto;
`

export const CalendarInput = styled.div`
    width: 100%;
    height: 56px;
    cursor: pointer;
    outline: none;
    border: none;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    background-color: #f7f7f7;
    border-bottom: 2px solid ${props => props.theme.colors.lightOrange};
    font-size: ${props => props.theme.fontSize.header};
    padding: ${props => props.theme.padding};
    text-align: center;
    border-top-right-radius: ${props => props.theme.borderRadius};
    border-top-left-radius: ${props => props.theme.borderRadius};


    & ~ label {
      font-size: ${props => props.theme.fontSize.text};
      position: absolute;
      top: 5px;
      right: 12px;
    }
`

export const ShadowTop = styled.div`
  background: transparent;
  width: 100%;
  position: absolute;
  top: 0;
  height: 50px;
  box-shadow: inset 0 25px 15px rgba(255, 255, 255, 0.72);
`

export const ShadowBottom = styled.div`
  background: transparent;
  width: 100%;
  position: absolute;
  bottom: 0;
  height: 50px;
  box-shadow: inset 0 -25px 15px rgba(255, 255, 255, 0.72);
`

export const CalendarContainer = styled.div`
  display: ${props => props.isShown ? "block" : "none"};
`
